/*
 * File: serizilize.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

/**
 * 格式化请求数据
 * @param  {Object} data 请求的表单数据
 * @return {Object}      格式化之后的后台需要的数据
 */
export function serialize(data) {
  const result = {};

  for (let item in data) {
    if (data.hasOwnProperty(item)) {
      // 空值不传
      if (data[item] === '' || data[item] === undefined) {
        continue;
      }

      // 日期转换为时间戳
      if (data[item] instanceof Date) {
        result[item] = +data[item];
        continue;
      }

      result[item] = data[item];
    }
  }

  return result;
}

/**
 * 格式化会员等级的排序数据  从小等级到大等级
 * @param  {Object} data 请求的表单数据
 * @return {Object}      格式化之后的后台需要的数据
 */
export const levelSort = (baseLevelList, levelList, str = 'levelId') => {
  if (!Array.isArray(levelList)) return levelList;
  if (!Array.isArray(baseLevelList)) { console.error('请传入等级数组格式'); return levelList };

  let baseLevelIds = baseLevelList.map(n => n[str]);
  let levels = [];
  baseLevelIds.forEach((e, i) => {
    if (levelList.indexOf(e) > -1) {
      levels.push(e);
    }
  });
  return levels;
};
